import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import CustomInput from "../../Core/Components/CustomInput";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import TableViewIcon from "../../Common/Svgs/TableViewIcon";
import GridViewIcon from "../../Common/Svgs/GridViewIcon";

const HubHeader = ({ search, setSearch, sort, setSort }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedView = searchParams.get("view");

  const [focus, setFocus] = useState(false);

  const handleView = () => {
    if (selectedView === "grid") {
      searchParams.set("view", "table");
      setSearchParams(searchParams);
      return;
    }

    searchParams.set("view", "grid");
    setSearchParams(searchParams);
  };

  return (
    <div className="h-[60px] bg-background-white px-6 py-2.5 border-t-[0.5px] border-light-grey flex items-center justify-between">
      <p className="font-poppins font-medium text-base text-black capitalize">
        Energy Breakdown
      </p>

      <div className="flex items-center gap-x-2">
        <CustomInput
          intent="search"
          prefix={
            <img src="/assets/icons/search.svg" alt="" className="mr-2" />
          }
          value={search}
          focus={focus}
          border={focus ? "success" : "none"}
          placeholder={focus ? null : "Search Hubs"}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          suffix={
            search.length > 0 ? (
              <CloseIcon
                className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                onClick={() => {
                  setFocus(false);
                  setSearch("");
                }}
              />
            ) : null
          }
        />

        <button
          type="button"
          className="w-[125px] h-[42px] flex items-center p-3 gap-x-3 rounded-md hover:bg-background-white-hover"
          onClick={() => setSort((prev) => (prev === "asc" ? "desc" : "asc"))}
        >
          <p className="font-poppins font-medium text-xs text-dark-gray capitalize">
            {sort === "asc" ? "High to Low" : "Low to High"}
          </p>

          <img
            src="/assets/icons/sort.svg"
            alt="Filters"
            className={` ${sort === "asc" ? "" : "rotate-180"}`}
          />
        </button>

        <button
          type="button"
          className="w-[119px] h-[42px] flex items-center p-3 gap-x-3 rounded-md hover:bg-background-white-hover"
          onClick={handleView}
        >
          <p className="font-poppins font-medium text-xs text-dark-gray capitalize">
            {selectedView === "grid" ? "Table View" : "Grid View"}
          </p>

          {selectedView === "grid" ? <TableViewIcon /> : <GridViewIcon />}
        </button>
      </div>
    </div>
  );
};

export default HubHeader;
